import { useMemo } from 'react';
import styled from 'styled-components';
import { isObject } from 'lodash';
import { spacing } from 'ui/theme';
import { TableCell } from 'ui/tableCell';
import { AlignTypes } from 'ui/tableHeader';
import { pxToRem } from 'utils/convert';
import { User, UserField } from '../types';
import { STARRED_FIELDS, NONSORTABLE_FIELD_TYPES } from '../constants';
import { UserProfileCell } from '../components/segmentationResults/usersTable/UserProfileCell';
import { getColumnCellValue } from '../utils';

const StyledTableCell = styled(TableCell)`
  padding: ${spacing.base};
  &:first-child {
    padding-left: ${pxToRem(44)};
  }
`;

// maxwidth of specific fields
const definedWidths: Record<string, number> = {
  [STARRED_FIELDS.email]: 580,
  [STARRED_FIELDS.userId]: 250,
};

// Given list of chosen user fields as columns, return list of column data for user table
export const useGetColumnData = (columns: UserField[]) => {
  const parsedColumns = useMemo(
    () =>
      columns.map((columnValue: UserField) => {
        const { title, field, fieldType } = columnValue;
        const isStarredField = field in STARRED_FIELDS;

        const isSortable = !!fieldType && !NONSORTABLE_FIELD_TYPES.includes(fieldType);

        return {
          align: 'flex-start' as AlignTypes,
          name: title,
          value: field,
          sortable: isSortable,
          width: definedWidths[field] || undefined,
          RowCell: ({ row }: { row: User }) => {
            const cellValue = getColumnCellValue(row, field);
            const cellDisplay = isObject(cellValue)
              ? JSON.stringify(cellValue)
              : cellValue?.toString();
            return (
              <StyledTableCell>
                {isStarredField ? <UserProfileCell column={field} row={row} /> : <>{cellDisplay}</>}
              </StyledTableCell>
            );
          },
        };
      }),
    [columns],
  );
  return parsedColumns;
};
